import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CreateUserCommand, User } from '@era/security-sdk';
import { SuggestedUserStoreSelectors } from '@era/stores';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserSearchBarComponent } from '../user-search-bar/user-search-bar.component';

@Component({
  selector: 'era-add-user-modal-ui',
  templateUrl: './add-user-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [UserSearchBarComponent, ReactiveFormsModule, AsyncPipe],
})
export class AddUserModalComponent {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly store = inject(Store);

  public readonly addForm: UntypedFormGroup;
  public readonly suggestedUsers$: Observable<User[]>;

  constructor() {
    this.addForm = this.createForm();
    this.suggestedUsers$ = this.store.select(SuggestedUserStoreSelectors.selectAllSuggestedUsers);
  }

  enterSelectedItem(event: User) {
    const user = {
      email: event?.email ?? '',
      displayName: event?.displayName ?? '',
      id: event?.id,
    };

    this.addForm.setValue(user);
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      displayName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      id: ['', Validators.required],
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  add(): void {
    const result: CreateUserCommand = {
      displayName: this.addForm.get('displayName')?.value ?? '',
      email: this.addForm.get('email')?.value ?? '',
      id: this.addForm.get('id')?.value ?? '',
    };

    this.activeModal.close(result);
  }
}
